export default "__VITE_ASSET__BNP$Y$Jf__"